import styled from "styled-components"
import SubHeader from "./SubHeader"
import MainHeader from "./MainHeader"
import Navbar from "./Navbar"

const Container = styled.div`
  // 1024 -> 768
  @media (min-width: 768px) {
    background-color: ${(props) => props.theme.colors.primary};
  }
  overflow-x: hidden;
`
const Wrapper = styled.div`
  width: 100%;
  min-width: 320px;
  max-width: 600px;
  min-height: 100dvh;
  margin: 0 auto;
  background-color: ${(props) =>
    props.$bgColor === "gray"
      ? props.theme.colors.neutral[200]
      : props.theme.colors.neutral[100]};
  position: relative;
  display: flex;
  flex-direction: column;
`
const Main = styled.main`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding-bottom:  ${(props) => (props.$hasNavBar ? "68px" : "0")};
  padding-top: ${(props) => (props.$hasHeader ? "56px" : "0")};
`

const DefaultLayout = ({ hasNavBar, headerType, variant, title, onBack, onMenuClick, onAdd, bgColor, children }) => {
  const hasHeader = headerType === "sub" || headerType === "main";
  
  return (
    <Container>
      <Wrapper $bgColor={bgColor}>
        {headerType === "sub" && 
          <SubHeader 
            variant={variant} 
            title={title} 
            onBack={onBack} 
            onMenuClick={onMenuClick}/>}
        {headerType === "main" && 
          <MainHeader 
            title={title}
            variant={variant}
            onAdd={onAdd}/>}
        <Main $hasHeader={hasHeader} $hasNavBar={hasNavBar}>
          {children}
        </Main>
        {hasNavBar && <Navbar/>}
      </Wrapper>
    </Container>
  )
}

export default DefaultLayout